// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edgecard {
  box-shadow: none;
}

.dont-show {
  text-transform: none;
  float: right;
  font-size: 12px;
  margin-top: 6px;
  color: var(--ion-color-primary);
}

ion-input,
ion-datetime {
  text-align: right;
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/components/wizard/licence-scanner/licence-scanner.component.scss"],"names":[],"mappings":"AAAA;EAEC,gBAAA;AACD;;AACA;EACC,oBAAA;EAAsB,YAAA;EAAc,eAAA;EAAiB,eAAA;EAAiB,+BAAA;AAMvE;;AAHA;;EAEC,iBAAA;EACA,YAAA;AAMD","sourcesContent":[".edgecard {\r\n\t-webkit-box-shadow:none;\r\n\tbox-shadow: none;\r\n}\r\n.dont-show {\r\n\ttext-transform: none; float: right; font-size: 12px; margin-top: 6px; color: var(--ion-color-primary)\r\n}\r\n\r\nion-input,\r\nion-datetime {\r\n\ttext-align: right;\r\n\topacity: 0.8;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
